<div class="sidebar-container">
	<button (click)="toggleSidebar()" class="sidebar-collapse-btn">
		<svg
			width="20"
			height="20"
			viewBox="0 0 20 20"
			fill="currentColor"
			xmlns="http://www.w3.org/2000/svg"
			class="sidebar-collapse-icon"
			[ngStyle]="{ transform: sidebarCollapsed ? 'scaleX(-1)' : 'scaleX(1)' }"
		>
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M5 10C5 9.85913 5.05943 9.72479 5.16366 9.63003L10.6637 4.63003C10.868 4.44428 11.1842 4.45933 11.37 4.66366C11.5557 4.86799 11.5407 5.18422 11.3363 5.36997L6.7933 9.5L17.5 9.5C17.7761 9.5 18 9.72386 18 10C18 10.2761 17.7761 10.5 17.5 10.5L6.7933 10.5L11.3363 14.63C11.5407 14.8158 11.5557 15.132 11.37 15.3363C11.1842 15.5407 10.868 15.5557 10.6637 15.37L5.16366 10.37C5.05943 10.2752 5 10.1409 5 10Z"
			></path>
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M2.5 2C2.77614 2 3 2.22386 3 2.5L3 17.5C3 17.7761 2.77614 18 2.5 18C2.22385 18 2 17.7761 2 17.5L2 2.5C2 2.22386 2.22386 2 2.5 2Z"
			></path>
		</svg>
	</button>

	<!-- SIDEBAR -->
	<div *ngIf="!sidebarCollapsed" class="sidebar-v2">
		<!-- LOGO SECTION - Fixed height -->
		<div class="p-3" style="flex-shrink: 0">
			<div
				routerLink="dashboard"
				routerLinkActive="active-menu-item"
				(click)="setPageTitle('Dashboard')"
				style="cursor: pointer"
			>
				<div class="px-3 pb-3">
					<img
						style="aspect-ratio: 2/1; padding: 0 0.75rem"
						src="../../assets/img/aclarian-logo2.png"
						alt="aclarian logo"
					/>
				</div>
			</div>
		</div>

		<!-- CLIENT SELECT SECTION - Fixed height -->
		<div style="flex-shrink: 0">
			<div class="px-3">
				<div class="pb-3">
					<div style="min-width: 100%">
						<p-select
							[options]="clients"
							[(ngModel)]="selectedClientId"
							[loading]="loadingClients$ | async"
							[disabled]="!hasMultipleClients"
							(onChange)="clientSelected($event)"
							[checkmark]="true"
							[filter]="true"
							optionLabel="name"
							optionValue="id"
							placeholder="Select a Client"
							class="w-full"
							[style]="{ width: '100%' }"
							[panelStyle]="{ width: '241px' }"
						/>
					</div>
				</div>
			</div>
		</div>

		<!-- MENU ITEMS SECTION - Takes remaining height -->
		<div style="flex: 1; min-height: 0">
			<div class="p-3 scrollable-menu-items">
				<div style="position: relative; margin-bottom: 16px">
					<p-iftalabel>
						<input
							class="px-2 pt-3"
							autocomplete="off"
							pInputText
							id="username"
							[(ngModel)]="filterText"
							style="width: 100%; height: 4rem"
							(input)="onFilterChange()"
						/>
						<label for="username">Search by form title</label>
					</p-iftalabel>

					<button *ngIf="filterText && filterText.length > 0" class="filter-clear-btn" (click)="clearFilter()">
						<span class="filter-clear-btn-text">x</span>
					</button>
				</div>
				@for (mod of filteredForms; track mod.id) { @if (hasChildItems(mod)) {
				<div class="menu-item-container">
					<div class="menu-item-header" (click)="toggleModule(mod)">
						<div class="menu-item-label-container">
							<span [ngStyle]="{ color: mod.expanded ? '#C3A76A' : 'lightgray' }">{{ mod.label }}</span>
						</div>
						<button class="menu-item-toggle-btn">
							<i
								[ngClass]="mod.expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"
								class="menu-item-chevron"
								[ngStyle]="{ color: mod.expanded ? '#C3A76A' : 'lightgray' }"
							></i>
						</button>
					</div>

					@if (mod.expanded && mod.children) {
					<div class="ml-3">
						@for (child of mod.children; track child.id) { @if (child.children && child.children.length > 0) {
						<div class="mb-1">
							<div class="menu-item-header" (click)="toggleModule(child)">
								<div class="menu-item-label-container">
									<span [ngStyle]="{ color: child.expanded ? '#C3A76A' : 'lightgray' }">{{ child.label }}</span>
								</div>
								<button class="menu-item-toggle-btn">
									<i
										[ngClass]="child.expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"
										class="menu-item-chevron"
										[ngStyle]="{ color: child.expanded ? '#C3A76A' : 'lightgray' }"
									></i>
								</button>
							</div>

							@if (child.expanded && child.children) {
							<div class="ml-3">
								@for (grandchild of child.children; track grandchild.id) {
								<div
									class="menu-item-link"
									[routerLink]="'/' + grandchild.route"
									routerLinkActive="active-menu-item"
									(click)="setPageTitle(grandchild.section)"
								>
									{{ grandchild.label }}
								</div>
								}
							</div>
							}
						</div>
						} @else if (child?.route) {
						<div
							class="menu-item-link"
							[routerLink]="'/' + child.route"
							routerLinkActive="active-menu-item"
							(click)="setPageTitle(child.section)"
						>
							{{ child.label }}
						</div>
						} }
					</div>
					}
				</div>
				} @else if (mod.route) {
				<div
					class="menu-item-no-children"
					[routerLink]="'/' + mod.route"
					routerLinkActive="active-menu-item"
					(click)="setPageTitle(mod.section)"
				>
					{{ mod.label }}
				</div>
				} }
			</div>
		</div>
	</div>
</div>
